import {createSelector} from 'reselect';
import { property, identity } from 'lodash'

export const getHomepageSettings = createSelector(property('homepageSettings'), identity);

export const isLoaded = createSelector(getHomepageSettings, property('isLoaded'));
export const getSelectedLanguage = createSelector(getHomepageSettings, property('lang'));
export const getError = createSelector(getHomepageSettings, property('error'));


// WEBPACK FOOTER //
// ./src/modules/HomepageSettings/selectors/index.js